export interface FinancialInstrumentsSchema {
  isin: { directorySchemaName: string; fieldName: string };
  securityType: { directorySchemaName: string; fieldName: string };
  issuer: { directorySchemaName: string; fieldName: string };
  nominalValue: { directorySchemaName: string; fieldName: string };
}
export interface CurrenciesSchema {
  currency: { directorySchemaName: string; fieldName: string };
}

export interface SenderOrRecipientDetailsSchema {
  custodianOrganization: {
    directorySchemaName: string;
    fieldName: string;
    directoryRecordFieldFilters: any;
  };

  brokerName: { directorySchemaName: string; fieldName: string };
}

export enum OrderOperationTypeForSearchParams {
  SecuritiesPurchase = 'securities_purchase',
  SecuritiesSale = 'securities_sale',
  SecuritiesWithdrawal = 'securities_withdrawal',
  SecuritiesDeposit = 'securities_deposit',
}
